import {rootState} from '@mintdata-wsp/common/state/RootState';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {AddonsSelector} from '@mintdata-wsp/wsp/ui/views/workspace/settings/billing/plans/AddonsSelector';
import {CloudAccessSelector} from '@mintdata-wsp/wsp/ui/views/workspace/settings/billing/plans/CloudAccessSelector';
import {LiveReceipt} from '@mintdata-wsp/wsp/ui/views/workspace/settings/billing/plans/LiveReceipt';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./ProductSelectionForm.less');
const cx = classnames.bind(styles);

@observer
export class ProductSelectionForm extends React.Component<any, any>
{
    @bind
    _onCancel()
    {
        controllers.ui.dialogs.hideDialog(Dialogs.ProductSelection);
    }

    @bind
    _onConfirm()
    {
        controllers.ui.dialogs.hideDialog(Dialogs.ProductSelection);
    }

    render()
    {
        const {storefront} = rootState.data;
        const {cloudAccessProducts} = storefront;
        const {addonProducts} = storefront;

        if( !cloudAccessProducts || !addonProducts )
            return null;

        return  <Column className={cx('productSelectionForm')}>
                    <Row className={cx('contentRow')}>
                        <Column className={cx('contentColumn')}>
                            <CloudAccessSelector/>

                            <Column className={cx('addonContentColumn')}>
                                <AddonsSelector/>
                            </Column>

                        </Column>
                        <Column className={cx('liveReceiptColumn')}>
                            <LiveReceipt/>
                        </Column>
                    </Row>
                    <Row className={cx('buttonsRow')}>
                        <WSPButton caption={"Cancel"} style={ButtonStyle.SimpleSecondary} onClick={this._onCancel}/>
                        <WSPButton caption={"Save"} style={ButtonStyle.Raised} onClick={this._onConfirm}/>
                    </Row>
                </Column>;
    }
}

